import { DateTimeInput } from './DateTimeInput'
import { withDateTimeInput } from './withDateTimeInput'

const ConnectedDateTimeInput = withDateTimeInput(DateTimeInput)

export { ConnectedDateTimeInput as DateTimeInput }
